<template>
  <fieldset class="min-w-0">
    <legend class="mb-2 text-sm font-medium">{{ legend || 'Produits proposés (10 max., 1 au choix)' }}</legend>
    <p v-if="loading" class="py-4 text-sm text-gray-500" role="status">Chargement des articles…</p>
    <p v-else-if="!products.length" class="rounded-lg bg-gray-50 p-4 text-sm text-gray-600" role="status">
      Aucun article disponible pour cette recherche. Essayez une autre référence.
    </p>
    <div v-else class="p-1">
      <div class="grid grid-cols-2 gap-3 sm:grid-cols-3">
        <button
          v-for="item in products"
          :key="item.id_produit"
          type="button"
          :aria-label="`Choisir ${item.reference} · ${item.couleur}`"
          :aria-pressed="selectedIds.includes(item.id_produit)"
          :disabled="disabled"
          :class="[
            'min-w-0 overflow-hidden rounded-lg border-2 text-left transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2 disabled:cursor-wait',
            selectedIds.includes(item.id_produit) ? 'border-indigo-600 bg-indigo-50' : 'border-gray-200 bg-white hover:border-indigo-300',
          ]"
          @click="$emit('choose', item.id_produit)"
        >
          <span class="relative flex h-32 items-center justify-center bg-gray-50 sm:h-40">
            <img
              v-if="item.image_url && !failedImages.has(item.image_url)"
              :src="item.image_url"
              :alt="`${item.reference} — ${item.couleur}`"
              class="h-full w-full object-contain"
              loading="lazy"
              referrerpolicy="no-referrer"
              @error="failedImages.add(item.image_url)"
            />
            <span v-else class="px-2 text-center text-xs text-gray-500">Photo indisponible</span>
            <span v-if="selectedIds.includes(item.id_produit)" class="absolute right-1 top-1 rounded bg-indigo-600 px-2 py-1 text-xs font-semibold text-white">✓ Candidat</span>
          </span>
          <span class="block space-y-1 p-2 text-sm">
            <span class="block break-words font-semibold">{{ item.reference }}</span>
            <span class="block break-words text-gray-600">{{ item.couleur || 'Couleur non renseignée' }}</span>
            <span class="block font-medium text-indigo-700">{{ total(item).amount != null ? `${replacementMoney(total(item).amount ?? 0)} HT au total` : 'Quantité à préciser' }}</span>
            <span class="block text-xs text-gray-600">{{ total(item).description }}</span>
          </span>
        </button>
      </div>
    </div>
  </fieldset>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { replacementMoney, replacementProductTotal } from '@/api/remplacements';
import type { ReplacementProduct, ReplacementSelection } from '@/api/remplacements';

const props = defineProps<{ products: ReplacementProduct[]; selectedIds: number[]; selections: ReplacementSelection[]; loading?: boolean; disabled?: boolean; legend?: string }>();
defineEmits<{ choose: [id: number] }>();
function total(product: ReplacementProduct) { return replacementProductTotal(product, props.selections.find(s => s.id_produit_remplacement === product.id_produit)); }
const failedImages = ref(new Set<string>());
</script>
